import {
  ChevronLeftIcon,
  ChevronRightIcon,
  FontSizeEnum,
  FontWeightEnum,
  Typography,
} from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { useNavigationToolkitItem } from '../hooks/useNavigationToolkitItem';
import { TNavigationItem } from '../types';

type TBroadcastScheduleProgramBodySegmentToolkitNavigationProps<T extends TNavigationItem> = {
  items: T[];
  activeItem: T | null;
  onChangeData: (data: T) => void;
};

export function BroadcastScheduleProgramBodySegmentToolkitNavigation<T extends TNavigationItem>({
  items,
  activeItem,
  onChangeData,
}: TBroadcastScheduleProgramBodySegmentToolkitNavigationProps<T>) {
  const { t } = useTranslation();
  const { handleNextItem, handlePreviousItem, hasNextItem, hasPreviousItem } =
    useNavigationToolkitItem({ items, activeItem, onChangeData });

  if (!activeItem) return null;

  return (
    <div className="flex w-full">
      {hasPreviousItem && (
        <div className="flex cursor-pointer items-center gap-1" onClick={handlePreviousItem}>
          <ChevronLeftIcon />
          <Typography fontSize={FontSizeEnum.Sm} weight={FontWeightEnum.Semibold}>
            {t('Anterior')}
          </Typography>
        </div>
      )}
      {hasNextItem && (
        <div className="flex w-full justify-end">
          <div className="flex cursor-pointer items-center gap-1" onClick={handleNextItem}>
            <Typography fontSize={FontSizeEnum.Sm} weight={FontWeightEnum.Semibold}>
              {t('Siguiente')}
            </Typography>

            <ChevronRightIcon />
          </div>
        </div>
      )}
    </div>
  );
}
